import Image from "next/image";
import useLazyVideo from "../../../../utils/hooks/useLazyVideo";
import MainBlob from "../../../animate/MainBlob";
import style from "./TutorialBlock.module.scss";

function TutorialBlock({ tutorialData, textData, hasBlobs = false }) {
	const [containerRef, videoRef, isInView] = useLazyVideo();

	const sectionClassName = hasBlobs ? `${style.section} ${style.blobsBack}` : style.section;

	return (
		<section ref={containerRef} className={sectionClassName}>
			<h2 className={style.title}>{textData.title}</h2>
			<div className={style.content}>
				<div className={style.info}>
					<ul className={style.list}>
						{tutorialData.map((item) => (
							<li key={item.title} className={style.item}>
								<p className={style.step}>{item.title}</p>
								<p className={style.description}>{item.description}</p>
							</li>
						))}
					</ul>
				</div>
				{textData.videoUrl !== undefined && (
					<video ref={videoRef} className={style.video} autoPlay={isInView} loop muted playsInline preload="none" poster={textData.posterUrl}>
						<source src={textData.videoUrl} type="video/mp4" />
					</video>
				)}
				{textData.youtubeUrl !== undefined && (
					<div className={style.youtubeUrlWrapper}>
						<iframe
							width="560"
							height="315"
							src={textData.youtubeUrl}
							title="YouTube video player"
							frameborder="0"
							allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
							className={style.youtubeVideo}
							loading="lazy"
						/>
					</div>
				)}

				{textData.videoUrl === undefined && textData.youtubeUrl === undefined && (
					<Image className={style.video} src={textData.posterUrl} unoptimized alt={textData.title} width={272} height={152} loading="lazy" />
				)}
			</div>
		</section>
	);
}

export default TutorialBlock;
